var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveFocus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Iris-Scan--Streamline-Flex",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Iris Scan Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iris-scan--identification-retina-secure-security-iris-scan-eye-brackets"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 20",
    stroke: "#4A57DA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.7318 7.00002c0 0.79503 -2.11854 3.59618 -4.73187 3.59618 -2.61334 0 -4.73186 -2.80115 -4.73186 -3.59618 0 -0.79502 2.11852 -3.59621 4.73186 -3.59621 2.61333 0 4.73187 2.80119 4.73187 3.59621Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    stroke: "#4A57DA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.0068 0.942627c0.3709 0.039948 0.7384 0.082773 1.1023 0.124943 0.9595 0.1112 1.7251 0.8763 1.8328 1.83618 0.0406 0.36154 0.0815 0.72667 0.1196 1.09511",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect_2",
    stroke: "#4A57DA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.0068 13.0574c0.3709 -0.04 0.7384 -0.0828 1.1023 -0.125 0.9595 -0.1112 1.7251 -0.8763 1.8328 -1.8362 0.0406 -0.3615 0.0815 -0.7266 0.1196 -1.0951",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect_3",
    stroke: "#4A57DA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.99316 0.942627c-0.37084 0.039948 -0.73836 0.082773 -1.10224 0.124943 -0.95949 0.1112 -1.72508 0.8763 -1.83285 1.83618 -0.04059 0.36154 -0.081513 0.72667 -0.119554 1.09511",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect_4",
    stroke: "#4A57DA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.99316 13.0574c-0.37084 -0.04 -0.73836 -0.0828 -1.10224 -0.125 -0.95949 -0.1112 -1.72508 -0.8763 -1.83285 -1.8362 -0.04059 -0.3615 -0.081513 -0.7266 -0.119554 -1.0951",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#4A57DA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7 8.24976c0.8 0 1.25 -0.45 1.25 -1.25s-0.45 -1.25 -1.25 -1.25 -1.25 0.45 -1.25 1.25 0.45 1.25 1.25 1.25Z",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveFocus);
export default __webpack_public_path__ + "static/media/active-focus.d0cd19552811c958517b7172eedcfdc9.svg";
export { ForwardRef as ReactComponent };